import Joi from 'joi';
import { SmartLinkWidgetType } from '../db/enums';

export const urlSchema = Joi.string().label('URL');

export const imageSchema = Joi.object({
  id: Joi.number().integer(),
  url: Joi.string(),
  uuid: Joi.string(),
});

export const widgetTypeSchema = Joi.string()
  .label('Type')
  .valid(...Object.values(SmartLinkWidgetType));

/**
 * Page number for paginated endpoints.
 *
 * The page is turned into a Prisma `skip`, which must be a positive integer.
 * Without these rules `?page=-1` or `?page=1.01` reaches Prisma, which throws
 * "Invalid value for skip argument" and the API answers 500 instead of 400.
 */
export const pageSchema = Joi.number().integer().min(0);

export const emailSchema = Joi.string().email({ tlds: { allow: false } });

export const passwordMinimumLength = 8;
export const passwordSchema = Joi.string().min(passwordMinimumLength);
